import { render, staticRenderFns } from "./DeliverySimulator.vue?vue&type=template&id=5f01f11e&"
import script from "./DeliverySimulator.vue?vue&type=script&lang=js&"
export * from "./DeliverySimulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports